import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'angular2-toaster';
import { ClickableBoxItem, HeaderInfo } from 'app/components/common/clickableBox/clickableBox.component';
import { AuthService } from 'app/services/auth.service';
import { UserRepository } from 'app/services/database/user.repository';
import { DeviceService } from 'app/services/device.service';
import { DevicesGroupService } from 'app/services/devicesGroup.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { DeviceModel } from 'app/views/devices/models/device.model';
import { UserModel } from 'app/views/user/models/user.model';
import { environment } from 'environments/environment';
import * as moment from 'moment';

@Component({
    selector: 'psm-devices-list',
    templateUrl: 'devicesList.component.html'
})

export class DevicesListComponent implements OnInit {

    public title;
    public groupId;

    // Prevents flickers
    public isDeviceListEmpty: boolean = false;
    public isDeviceListLoading: boolean = false;

    public deviceModels: DeviceModel[] = [];
    public sortedDeviceBoxes: ClickableBoxItem[] = [];

    private user: UserModel;
    private logger: Logger;
    public hasWebView = true;

    constructor(
        loggerFactory: LoggerFactory,
        private route: ActivatedRoute,
        private authService: AuthService,
        private deviceService: DeviceService,
        private devicesGroupService: DevicesGroupService,
        private userRepository: UserRepository,
        private toasterService: ToasterService,
        private translate: TranslateService
    ) {
        this.logger = loggerFactory.create('DeviceListComponent');
    }

    public async ngOnInit() {
        this.groupId = this.route.snapshot.params.id;

        let user = await this.authService.getCurrentUser();
        let uid = user.uid;

        this.user = await this.userRepository.get(uid);

        if (this.user.devices !== undefined) {
            this.isDeviceListLoading = true;
            try {
                try {
                    this.deviceModels = await this.deviceService.getUserDeviceList(uid);
                    this.hasWebView = !!this.deviceModels.find(x => x.displayInfo === 'web');
                } catch (err) {
                    this.toasterService.popAsync('error', '', 'modules.devices.list.failed-to-retrieve-list');
                    this.logger.error(`An error occured while getting devices for user '${uid}'.`, err);
                }
                let titleTranslate = await this.translate.get('modules.devices.list.title').toPromise();
                if (this.groupId) {
                    let fromGroupTranslate = await this.translate.get('modules.devices.list.from-group').toPromise();
                    let group = await this.devicesGroupService.getDevicesGroup(this.groupId);
                    let groupName = group.name;
                    this.title = `${titleTranslate} ${fromGroupTranslate} ${groupName}`;
                    for (let deviceModel of this.deviceModels) {
                        if (deviceModel.groupId) {
                            if (deviceModel.groupId === this.groupId) {
                                this.sortedDeviceBoxes.push(await this.createClickableItem(deviceModel));
                            }
                        }
                    }
                    if (this.sortedDeviceBoxes.length === 0) {
                        this.logger.debug(`No device found for user ${user.uid} in group ${this.groupId}`);
                        this.isDeviceListEmpty = true;
                    }
                } else {
                    this.title = titleTranslate;
                    for (let deviceModel of this.deviceModels) {
                        this.sortedDeviceBoxes.push(await this.createClickableItem(deviceModel));
                    }
                }
            } catch (e) {
                this.toasterService.popAsync('error', '', 'modules.devices.list.failed-to-display-list');
                this.logger.error(`An error occured while displaying devices for user '${uid}'.`, e);
                this.isDeviceListEmpty = true;
            }
        } else {
            this.isDeviceListEmpty = true;
            this.hasWebView = false;
        }
        this.isDeviceListLoading = false;
    }

    private async createClickableItem(device: DeviceModel): Promise<ClickableBoxItem> {
        let link = `/devices/edit/${device.id}`;
        let item = new ClickableBoxItem(device.name, link);
        item.image = '../../assets/images/tv_icon.jpg';

        let label = await this.translate.get('time.last-modified').toPromise();
        let date = moment(device.modificationDate);
        item.headerInfo.push(new HeaderInfo(label, date.format('LLL'), 'fa fa-pencil-square-o'));

        try {
            if (device.metadata.state) {
                let tag = await this.deviceService.createDeviceTag(device);
                item.tags.push(tag);
            }
        } catch (e) {
            this.logger.debug(`Device ${device.id} has no metadata.`);
        }
        if (device.groupId) {
            let deviceGroupTag = await this.devicesGroupService.createDevicesGroupTag(device.groupId);
            item.tags.push(deviceGroupTag);
        }
        return item;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/devices/devicesList.component.ts